// Browser-side upload for admin-owned images (partner logos). Same
// two-step flow as the manager's helper: ask the API for a presigned PUT,
// then PUT the bytes straight to DO Spaces with the signed headers.
import { client } from '../main.js';

const TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'] as const;
type LogoType = (typeof TYPES)[number];

export async function uploadPartnerLogo(file: File): Promise<string> {
  const contentType = file.type;
  if (!(TYPES as readonly string[]).includes(contentType)) {
    throw new Error('Unsupported image type. Use SVG, PNG, JPEG, or WebP.');
  }
  const sig = await client.uploads.getSignature({
    kind: 'partner-logo',
    contentType: contentType as LogoType,
    filename: file.name,
  });
  const res = await fetch(sig.uploadUrl, {
    method: 'PUT',
    headers: sig.requiredHeaders,
    body: file,
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Upload failed (${res.status}): ${body.slice(0, 200) || 'no body'}`);
  }
  return sig.publicUrl;
}
